var VueResource = require('vue-resource')

export default {
  solicitarFeedback (feedId, editorEmail, ownerUser) {
    let body = {
      app_id: process.env.onesignal.appId,
      filters: [
        {'field': 'tag', 'key': 'email', 'relation': '=', 'value': editorEmail}
      ],
      headings: { 'en': ownerUser.displayName },
      contents: {'en': 'Te solicito feedback'},
      url: '/#/feedback/' + feedId,
      chrome_web_icon: ownerUser.photoURL
    }
    let headers = { 'Authorization': 'Basic ' + process.env.onesignal.restapikey }
    let options = { headers: headers }
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then((res) => {
      // console.log(res)
    },
    (error) => {
      console.log(error)
    })
  },
  enviarFeedback (feedback, editorUser) {
    let content
    if (feedback.isEspontaneo) {
      content = 'Te dio feedback espontaneo'
    } else {
      content = 'Finalizo el feedback que solicitaste'
    }
    let body = {
      app_id: process.env.onesignal.appId,
      filters: [
        {'field': 'tag', 'key': 'email', 'relation': '=', 'value': feedback.owner}
      ],
      headings: { 'en': editorUser.displayName },
      contents: { 'en': content },
      url: '/#/mis-feedbacks/mi-feedback/' + feedback['.key'],
      chrome_web_icon: editorUser.photoURL
    }
    let headers = { 'Authorization': 'Basic ' + process.env.onesignal.restapikey }
    let options = { headers: headers }
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then((data) => {
      // console.log(data)
    },
    (error) => {
      console.log(error)
    })
  },
  agradecer (feedback, editorUser) {
    let content = 'Te agradeció por el feedback'
    let body = {
      app_id: process.env.onesignal.appId,
      filters: [
        {'field': 'tag', 'key': 'email', 'relation': '=', 'value': feedback.editor}
      ],
      headings: { 'en': editorUser.displayName },
      contents: { 'en': content },
      url: '/#/mis-feedbacks/mi-feedback/' + feedback['.key'],
      chrome_web_icon: editorUser.photoURL
    }
    let headers = { 'Authorization': 'Basic ' + process.env.onesignal.restapikey }
    let options = { headers: headers }
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then((data) => {
      // console.log(data)
    },
    (error) => {
      console.log(error)
    })
  },
  enviarObjetivos (acuerdo, userLider) {
    let body = {
      app_id: process.env.onesignal.appId,
      filters: [
        {'field': 'tag', 'key': 'email', 'relation': '=', 'value': acuerdo.owner}
      ],
      headings: { 'en': userLider.displayName },
      contents: { 'en': 'Te ha seteado nuevos objetivos' },
      url: '/#/mis-objetivos/mi-acuerdo-detail/' + acuerdo['.key'],
      chrome_web_icon: userLider.photoURL
    }
    let headers = { 'Authorization': 'Basic ' + process.env.onesignal.restapikey }
    let options = { headers: headers }
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then((data) => {
      // console.log(data)
    },
    (error) => {
      console.log(error)
    })
  },
  solicitarObjetivos (acuerdoId, editor, ownerUser) {
    let body = {
      app_id: process.env.onesignal.appId,
      filters: [
        {'field': 'tag', 'key': 'email', 'relation': '=', 'value': editor}
      ],
      headings: { 'en': ownerUser.displayName },
      contents: { 'en': 'Te ha solicitado nuevos objetivos' },
      url: '/#/acuerdo-objetivos/acuerdo/' + acuerdoId,
      chrome_web_icon: ownerUser.photoURL
    }
    let headers = { 'Authorization': 'Basic ' + process.env.onesignal.restapikey }
    let options = { headers: headers }
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then((data) => {
      // console.log(data)
    },
    (error) => {
      console.log(error)
    })
  },
  finalizarObjetivos (acuerdoId, editorUser, owner) {
    let body = {
      app_id: process.env.onesignal.appId,
      filters: [
        {'field': 'tag', 'key': 'email', 'relation': '=', 'value': owner}
      ],
      headings: { 'en': editorUser.displayName },
      contents: { 'en': 'Ha dado por finalizado tus objetivos vigentes' },
      url: '/#/mis-objetivos/mi-acuerdo-detail/' + acuerdoId,
      chrome_web_icon: editorUser.photoURL
    }
    let headers = { 'Authorization': 'Basic ' + process.env.onesignal.restapikey }
    let options = { headers: headers }
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then((data) => {
      // console.log(data)
    },
    (error) => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/notifications.js